import type { DialogMessageOptions } from '../type/message-options';
import type { MessageResult } from '../type/message-result';
import type { Observable } from 'rxjs';
import { MessageService } from './message.service';
import { I18nProviderInjectionToken } from '../i18n/i18n.scope';
import type { TranslateAbleText } from '@pct-ng/i18n';
import type { StrictOmit } from '@pct-ts/typing';

export type OpenDialogOptionsParameter = StrictOmit<DialogMessageOptions, 'type'>;
export type OpenConfirmDialogOptionsParameter = StrictOmit<OpenDialogOptionsParameter, 'buttons'>;
export type OpenOKDialogOptionsParameter = OpenConfirmDialogOptionsParameter;

const i18nScope = I18nProviderInjectionToken.scope;

function generateTranslateKey(key: string): string {
  return `${i18nScope}.${key}`;
}

function generateButtonTranslateKey(key: string): string {
  return generateTranslateKey(`BUTTON.${key}`);
}

export function openDialog(
  options: OpenDialogOptionsParameter,
): Observable<MessageResult | undefined> {
  return MessageService.INSTANCE.open({ ...options, type: 'DIALOG' });
}

export function openConfirmDialog(
  options: OpenConfirmDialogOptionsParameter,
): Observable<MessageResult | undefined> {
  const newOptions = {
    ...options,
    buttons: {
      submit: {
        show: true,
        label: generateButtonTranslateKey('YES'),
      },
      // TODO: the translation key will change in the core package
      cancel: { show: true, label: generateButtonTranslateKey('CANCEL') },
    },
  } satisfies StrictOmit<DialogMessageOptions, 'type'>;

  return openDialog(newOptions);
}

export function openOKDialog(
  options: OpenOKDialogOptionsParameter,
  okLabel?: TranslateAbleText,
): Observable<MessageResult | undefined> {
  const newOptions = {
    ...options,
    buttons: {
      submit: {
        show: true,
        label: okLabel ?? generateButtonTranslateKey('OK'),
      },
      cancel: { show: false },
    },
  } satisfies StrictOmit<DialogMessageOptions, 'type'>;

  return openDialog(newOptions);
}
